<template>
  <div class="vanguard-payment-form">
      <span class="warning-message">
        <strong>{{ $t('form.warningMessage1click') }}</strong>
      </span><br>
    <div class="btn btn-lg btn-green vanguard-validate-order-button" @click.prevent="validateOrder">
      {{ buttonLabel }}
    </div>
  </div>
</template>
<script>
import * as mutations from '../store/mutations';

export default {
  props: {
    buttonLabel: {
      type: String,
      default: 'J’achète en 1clic'
    }
  },
  methods: {
    validateOrder() {
      this.$store.commit(mutations.SET_ORDER_COMPLETE, true);
    }
  }
};
</script>



// WEBPACK FOOTER //
// validate-order-button.vue?57d8abf4